import { render, staticRenderFns } from "./CryptoPicker.vue?vue&type=template&id=588538a4&"
import script from "./CryptoPicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./CryptoPicker.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CryptoPicker.vue?vue&type=style&index=0&id=588538a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
